import React from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/style.scss';
import './index.scss';
// Lists may shrink their columns to fit the screen (utils/tables)
import './utils/tables';
import { endViewAsIfBrowserWasClosed } from './utils/viewAs';

// "View as reseller" ends when the browser is closed (utils/viewAs)
endViewAsIfBrowserWasClosed();

const App = require('./app').default;

ReactDOM.render( 
	<App /> , document.getElementById('root')
);